export type ContractStatusColor = 'default' | 'error' | 'success' | 'warning';

export const mapDatabaseStatusToDisplay = (status: string | null | undefined): string => {
    if (status === null || status === undefined || status === '') return 'ACTIV';
    if (status === '!') return 'PASIV';
    if (status === '!!') return 'EXPIRAT';
    return status;
};

export const getContractStatusColor = (status: string | null | undefined): ContractStatusColor => {
    switch (mapDatabaseStatusToDisplay(status)) {
        case 'ACTIV':
        case 'OK':
            return 'success';
        case 'PASIV':
        case 'EXPIRAT':
            return 'warning';
        case 'INV':
        case 'EXP':
            return 'error';
        default:
            return 'default';
    }
};
